import { twMerge } from "tailwind-merge";

export const VideoCustom = ({videoRef, className, url, videoName}) => {
    return (

        <video
            ref={videoRef ? videoRef : null}
            muted
            loop
            autoPlay
            playsInline
            preload="metadata"
            className={twMerge(`rounded-sm w-full h-full object-cover`, className)}
        >
            <source
                src={ url ? url : `${process.env.REACT_APP_URL_CLOUDFARE}video/${videoName}.mp4`}
                type="video/mp4"
            />
            <source
                src={ url ? url : `${process.env.REACT_APP_URL_CLOUDFARE}video/${videoName}.webm`}
                type="video/webm"
            />
        </video>
    );
};